import './sass/styles.css'
import { BrowserRouter,Routes,Route } from "react-router-dom"
import UserLayout from './components/UserLayout';
import BlogProvider from './components/context.js/BlogContext';
import LandingPages from './components/LandingPages';
import MyModal from './components/PostModal';
import Profile from './components/Profile';
import Explore from './components/Explore';
import SinglePost from './components/SinglePost';

function App() {
  return (
    <>
    <BlogProvider>
<BrowserRouter>
<Routes>


<Route  path='' element={<UserLayout /> }>


<Route path='/' element={<LandingPages />}/>
<Route path='/profile' element={<Profile />}/>
<Route path='/explore' element={<Explore />}/>
<Route path="/singlePost" element={ <SinglePost/>}/>
</Route>


</Routes>


</BrowserRouter>
</BlogProvider>
    </>
  );
}

export default App;
